
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ProjectDetailsSwitchTooltip extends Vue {
  @Prop() tooltipTextOn!: string
  @Prop() tooltipTextOff!: string
}
